<template>
  <div class="active-account">
    <div>
      <i class="active-account__icon material-icons">check_circle</i>
      <span class="active-account__title">
        {{ $t('ACCOUNT.STATUS.ACTIVE') }}
      </span>
      <small class="active-account__expire-date">
        &nbsp;|&nbsp;
        {{ $t('ACCOUNT.STATUS.EXPIRE_DATE') }}:
        <span>{{ expirationDate }}</span>
      </small>

      <ElButton
        v-if="canExtend"
        class="active-account__extend-button"
        size="small"
        type="primary"
        :loading="loading"
        @click.native="$emit('extend')"
      >
        {{ $t('ACCOUNT.STATUS.EXTEND_MEMBERSHIP') }}
      </ElButton>
    </div>

    <p v-if="canExtend" class="active-account__description">
      {{ $t('ACCOUNT.STATUS.EXTENDABLE_DESC') }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ActiveAccount',
  props: {
    expirationDate: {
      type: String,
      default: '-',
    },
    canExtend: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.active-account {
  &__icon {
    color: $lb-color-success;
  }

  &__title {
    color: $lb-color-success;
  }

  &__extend-button {
    margin-left: calc($global-margin / 2);
    @include rtl() {
      margin-left: 0;
      margin-right: calc($global-margin / 2);
    }
  }

  &__description {
    margin-top: $global-margin / 2;
    margin-bottom: 0;
    // to align with Expire icon
    margin-left: rem-calc(3);
    @include rtl() {
      margin-left: 0;
      margin-right: rem-calc(3);
    }
    font-size: $lb-small-font-size;
    color: $lb-black;
  }
}
</style>
